import usePermissions from "hooks/usePermissions";
const _checkPermissions = (permissions, anyPermissions, isPermitted) => {
  if (Array.isArray(permissions)) {
    return anyPermissions ? permissions.find(isPermitted) : permissions.every(isPermitted);
  }
  return isPermitted(permissions);
};
const IfPermitted = ({ children, permissions, anyPermissions = false }) => {
  const { isPermitted } = usePermissions();
  return !permissions || permissions.length === 0 || _checkPermissions(permissions, anyPermissions, isPermitted) ? children : null;
};
export default IfPermitted;
